import React, { useState } from "react";
import moment from 'moment';
import { formatDate } from '../../../utils/commonFunctions';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import AllOpenItemsTable from './AllOpenItemsTable';
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { Modal } from "reactstrap";
import { Link } from "react-router-dom";

interface Props {
  data: any;
  tableHeader: TableHeadersType[];
  editEntry?: Function;
  download?: Function;
  history?: any;
  activeTab?: string;
  handleSendOpenItemEmail?: (id: number) => void;
}
class AllOpenItemsTableData extends React.Component<Props> {

  getStatusClass = (status: number) => {
    switch (status) {
      case 0:
        return 'pending';
      case 1:
        return 'incomplete';
      case 2:
        return 'approval-pending';
      case 3:
        return 'complete';
      default:
        return;
    }
  }

  renderViewOpenItemToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        View Open Item
      </Tooltip>
    )
  }

  renderEditOpenItemToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Edit Open Item
      </Tooltip>
    )
  }

  renderSummaryTooltip = (props: any, data: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        {data}
      </Tooltip>
    )
  }

  render() {
    const {
      data,
      tableHeader,
      editEntry,
      // deleteEntry,
      download,
      activeTab,
      handleSendOpenItemEmail
    } = this.props
    return data?.map((dataItem: any, index: number) => {

      let finalDate = dataItem?.date_modified ? formatDate(dataItem?.date_modified) : '';
      let finalSummary = dataItem?.summary?.length > 20 ? `${dataItem?.summary?.slice(0, 10)}...` : dataItem?.summary;

      let status: string;
      if (dataItem?.status_code === 0) status = 'Pending'
      if (dataItem?.status_code === 1) status = 'Incomplete'
      if (dataItem?.status_code === 2) status = 'Approval Pending'
      if (dataItem?.status_code === 3) status = 'Complete'
      if (dataItem) {
        return (
          <tr key={index}>
            {
              tableHeader?.length && tableHeader?.map((item: any, i: number) => {
                if (item?.value === 'finalDate') {
                  return <td>{finalDate}</td>
                }
                else if (item?.value === 'summary') {
                  return <>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={this.renderSummaryTooltip('', dataItem?.summary)}
                    >
                      <td>{finalSummary}</td>
                    </OverlayTrigger>
                  </>
                }
                else if (item?.value === 'job_end_date') {
                  return <td style={{ width: '100px' }}>{formatDate(dataItem?.job_end_date)}</td>
                }
                else if (item?.value === 'first_due_date') {
                  return <td style={{ width: '100px' }}>{formatDate(dataItem?.first_due_date)}</td>
                }
                else if (item.value === 'modified_by') {
                  return <td style={{ width: '100px' }}>
                      {
                          <>
                           <div>{dataItem.first_name + " " + dataItem.last_name }</div>
                           <div className="mt-1">{moment.utc(dataItem?.date_modified).local().format('DD-MM-YY, h:mm a')}</div>
                          </>
                      }</td>
              }
                else if (item?.value === 'job_type') {
                  return <td>
                    <div> {dataItem[item?.value]} </div>
                    <label> {dataItem?.job_id} </label>
                  </td>

                } else if (item?.value === 'first_item_due') {
                  return <td>
                    {dataItem?.first_item_due}
                    {dataItem?.due_items_count > 1 && <span className='ml-1 doc-count-badge'>{`+${dataItem?.due_items_count - 1}`}</span>}
                  </td>
                } else if (item?.value === 'status_code') {
                  return <td style={{ width: '100px' }}>
                    <p className={`status-${this.getStatusClass(dataItem?.status_code)} text-center`}>
                      {status ? status : 'Pending'}
                    </p>
                  </td>
                }
                else if (dataItem[item?.value]) {
                  return <td> {dataItem[item?.value]}</td>
                }
                else {
                  return <td> --/-- </td>
                }

              })
            }
            <td style={{ width: '100px' }}>
              <div className="d-flex justify-content-center align-items-center">
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={this.renderViewOpenItemToolTip}
                >
                  <Link
                  to={`/admin-reports/all-open-items/all-open-items-view/${dataItem?.open_item_id}`}
                  target="_blank"
                  >
                    <span className="d-inline-block pointer">
                      <span
                        className="las la-eye"
                        style={{
                          fontSize: '20px',
                          color: '#484848',
                          background: 'rgb(253 245 244)',
                          padding: '8px',
                          margin: '0px 0 0 3px',
                          verticalAlign: 'middle'
                        }}
                      >
                      </span>
                    </span>
                  </Link>
                </OverlayTrigger>
              </div>
            </td>
          </tr>
        )
      }
    })
  }
}

export default AllOpenItemsTableData;